// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconAngleUpCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
            <path
                fill="#4D4D4D"
                d="M7,14.75 C10.8554688,14.75 14,11.6054688 14,7.75 C14,3.89453125 10.8554688,0.75 7,0.75 C3.14453125,0.75 0,3.89453125 0,7.75 C0,11.6054688 3.14453125,14.75 7,14.75 Z M10.3085938,8.16015625 C10.5546875,8.40625 10.5546875,8.84375 10.3085938,9.08984375 C10.0625,9.3359375 9.625,9.3359375 9.37890625,9.08984375 L7,6.7109375 L4.62109375,9.08984375 C4.375,9.3359375 3.96484375,9.3359375 3.69140625,9.08984375 C3.4453125,8.84375 3.4453125,8.40625 3.69140625,8.16015625 L6.53515625,5.31640625 C6.78125,5.0703125 7.21875,5.0703125 7.46484375,5.31640625 L10.3085938,8.16015625 Z"
            />
        </svg>
    );
};

export default React.memo(IconAngleUpCircle);
